import { environment } from '@env/environment';
import {
  ConnectedServiceItem,
  // OUTLAW_API_ROUTES,
  OutlawCoreConfig,
} from '@outlaw/core';

const connectedServiceUrls: ConnectedServiceItem[] = [
  // {
  //   url: environment.argoApiUrl,
  //   route: OUTLAW_API_ROUTES.userRoute,
  // },
  // {
  //   url: environment.paymentServiceUrl,
  //   route: OUTLAW_API_ROUTES.checkAccessToken,
  // },
];

export const outlawCoreConfig: OutlawCoreConfig = {
  api: {
    followUrl: 'api/followers',
    communityUrl: '/api',
    baseUrl: environment.communityApiUrl,
  },
  externalApi: {
    passportUrl: environment.passportExternalUrl,
    connectedServiceUrls,
  },
  passportUrl: environment.passportUrl,
  profileUrl: environment.profileUrl,
  serviceKey: {
    passport: environment.passportServiceKey,
    style: environment.styleServiceKey,
  },
};
